export default {

    clearingModelsState (state){
        return state.clearingModels;
    },

    hasRequestPermission: (state) => (request) => {
        if(request.url.includes('auth/')){
            return true;
        }
        if(state.user.authenticated == false){
            return false;
        }
        if(state.entityUid === null){
            if(request.url.includes(`${state.entityModelName}/`) || request.url.includes('user/')){
                return true;
            }
            return false;
        }
        return true;
    },

    anonymousUser(){
        return {
            authenticated: false,
            token: null,
            email: '',
            first_name: '',
            last_name: '',
            uid: '',
        };
    },

    authenticatedUser(state){
        return state.user;
    },

    userIsAuthenticated(state){
        return (state.user.authenticated === true);
    },

    // moved to computed for reactivity purpose
    // way to reproduce bug if you reactivate this:
    // - create a user
    // - click the link received by email
    // - fill the password
    // - once logged browse the app (optional)
    // - logout
    // - you are now in the set-password view and not in the login view

    // isLocationResetPassword(){
    //     const regex = RegExp('/(re)?set-password/');
    //     return regex.test(window.location.href);
    // },

    isLocationSecureConnect(){
        return window.location.href.includes('secure-connect');
    },

    locationQueryParams(){
        // Since URLSearchParams is not yet well supported
        // Code from https://gist.github.com/pirate/9298155edda679510723
        const decodeURLParams = search => {
            const hashes = search.slice(search.indexOf('?') + 1).split('&');
            return hashes.reduce((params, hash) => {
                const split = hash.indexOf('=');

                if (split < 0) {
                    return Object.assign(params, {
                        [hash]: null
                    });
                }

                const key = hash.slice(0, split);
                const val = hash.slice(split + 1);

                return Object.assign(params, { [key]: decodeURIComponent(val) });
            }, {});
        };
        return decodeURLParams(window.location.href);
    },

};



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/concretejs/store/module-auth/getters.js
// module id = null
// module chunks = 